import { render, staticRenderFns } from "./addServicio.vue?vue&type=template&id=d7805478&scoped=true"
import script from "./addServicio.vue?vue&type=script&lang=js"
export * from "./addServicio.vue?vue&type=script&lang=js"
import style0 from "./addServicio.vue?vue&type=style&index=0&id=d7805478&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7805478",
  null
  
)

export default component.exports